import { useEffect } from 'react';
import { Button, Cell, Divider, Modal, Navigation, Spacer, Text } from '@vinted/web-ui';
import { X16 } from '@vinted/monochrome-icons';
import useTranslate from 'hooks/useTranslate';
import { navigateToPage } from 'libs/utils/window';
import { GO_TO_TAXPAYER_FORM_URL, TAXPAYER_EDUCATION_URL } from 'constants/routes';
import { dismissTaxpayerRestrictionModal } from 'data/api';
import useTracking from 'hooks/useTracking';
import { clickEvent, viewEvent } from 'libs/common/event-tracker/events';
import { ViewableElement } from 'constants/tracking/viewable-elements';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TaxpayerRestrictionInfoModal = _ref => {
  let {
    show,
    isSellingBlocked,
    screen,
    onClose
  } = _ref;
  const translate = useTranslate('taxpayer_restriction_info_modal');
  const {
    track
  } = useTracking();
  const title = isSellingBlocked ? translate('selling_blocked.title') : translate('restricted.title');
  const body = isSellingBlocked ? translate('selling_blocked.body') : translate('restricted.body');
  const currentClickableElement = isSellingBlocked ? ClickableElement.TaxpayersSalesBlockModal : ClickableElement.TaxpayersBalanceBlockModal;
  useEffect(() => {
    if (!show) return;
    track(viewEvent({
      screen,
      target: isSellingBlocked ? ViewableElement.TaxpayersSalesBlockModal : ViewableElement.TaxpayersBalanceBlockModal
    }));
  }, [track, show, isSellingBlocked, screen]);

  const handleFinaliseReport = () => {
    track(clickEvent({
      screen,
      target: currentClickableElement,
      targetDetails: 'finalise'
    }));
    dismissTaxpayerRestrictionModal();
    navigateToPage(GO_TO_TAXPAYER_FORM_URL);
  };

  const handleLearnMore = () => {
    track(clickEvent({
      screen,
      target: currentClickableElement,
      targetDetails: 'learn'
    }));
    dismissTaxpayerRestrictionModal();
    navigateToPage(TAXPAYER_EDUCATION_URL);
  };

  const handleClose = () => {
    track(clickEvent({
      screen,
      target: currentClickableElement,
      targetDetails: 'close'
    }));
    onClose();
  };

  return /*#__PURE__*/_jsxs(Modal, {
    show: show,
    className: "u-flexbox u-flex-direction-column",
    children: [/*#__PURE__*/_jsx(Navigation, {
      body: /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Title,
        text: "Submit your DAC7 report",
        bold: true
      }),
      right: /*#__PURE__*/_jsx(Button, {
        styling: Button.Styling.Flat,
        onClick: handleClose,
        testId: "taxpayer-restriction-modal-close",
        iconName: X16,
        inline: true
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Cell, {
      children: [/*#__PURE__*/_jsx(Text, {
        type: Text.Type.Heading,
        text: title
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Body,
        text: body
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), /*#__PURE__*/_jsx(Button, {
        styling: Button.Styling.Filled,
        text: "Finalise your report",
        onClick: handleFinaliseReport
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), /*#__PURE__*/_jsx(Button, {
        styling: Button.Styling.Outlined,
        text: "Learn more about DAC7",
        onClick: handleLearnMore
      })]
    })]
  });
};

export default TaxpayerRestrictionInfoModal;